import useTranslator from "../../hooks/useTranslator";
import type { UserRole } from "../../pages/auth/authFlow";
import { SidePanel, StepBars } from "../design";
import "./AuthSidePanel.css";
import "./AuthForm.css";

interface AuthSidePanelProps {
  role: UserRole;
  /** 1 = choose a role, 2 = log in or sign up, 3 = onboarding.
      Leave out on pages outside the sign-up steps (no step bars). */
  step?: 1 | 2 | 3;
  /** small line under the step bars; defaults to the Welcome page line */
  caption?: string;
}

const ROLES: UserRole[] = ["tenant", "landlord", "guarantor"];

const AuthSidePanel = ({ role, step, caption }: AuthSidePanelProps) => {
  const { _t } = useTranslator();

  const copy: Record<
    UserRole,
    { eyebrow: string; headline: string; body: string }
  > = {
    tenant: {
      eyebrow: _t("forTenants"),
      headline: _t("welcomeTenantHeadline"),
      body: _t("welcomeTenantBody"),
    },
    landlord: {
      eyebrow: _t("forLandlordsAndAgents"),
      headline: _t("welcomeLandlordHeadline"),
      body: _t("welcomeLandlordBody"),
    },
    guarantor: {
      eyebrow: _t("forGuarantors"),
      headline: _t("welcomeGuarantorHeadline"),
      body: _t("welcomeGuarantorBody"),
    },
  };
  const active = copy[role];

  return (
    <SidePanel as="div" className="form-left auth-side-panel">
      <div className="auth-side-copy">
        <p className="auth-side-eyebrow">{active.eyebrow}</p>
        <h2>{active.headline}</h2>
        <p className="auth-side-body">{active.body}</p>
      </div>
      {step && (
        <StepBars
          className="auth-side-foot"
          total={ROLES.length}
          current={step}
          caption={caption ?? _t("oneAccountThreeWaysToUseSkor")}
        />
      )}
    </SidePanel>
  );
};

export default AuthSidePanel;
